import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ItemCardWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hovered',
})<{ hovered?: boolean }>(({ hovered }) => ({
  padding: 4,
  borderRadius: 12,
  width: 'fit-content',
  maxWidth: '100%',
  justifySelf: 'start',
  ...(hovered && {
    backgroundColor: 'var(--dk-accent-soft, #EBF3FB)',
  }),
}));

export const ItemCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hovered',
})<{ hovered?: boolean }>(({ hovered }) => ({
  position: 'relative',
  borderRadius: 8,
  width: 152,
  minWidth: 0,
  border: '1px solid var(--dk-line, var(--GrayScale-gray_3, #E7E9EC))',
  background: 'var(--dk-bg, var(--GrayScale-gray_White, #FFF))',
  overflow: 'visible',
  ...(hovered && {
    border: '1px solid var(--dk-accent-line, var(--accent-blue-blue-32, #ADCEEF))',
  }),
}));

export const ThumbnailWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})<{ clickable?: boolean }>(({ clickable }) => ({
  position: 'relative',
  cursor: clickable ? 'pointer' : 'default',
}));

export const Thumbnail = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isImage',
})<{ isImage?: boolean }>(({ isImage }) => ({
  padding: isImage ? 0 : '14px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  height: 76,
  overflow: 'hidden',
  borderTopLeftRadius: 7,
  borderTopRightRadius: 7,
  '& > img': {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: isImage ? 'cover' : 'contain',
  },
}));

export const ThumbnailOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.4)',
  borderTopLeftRadius: 7,
  borderTopRightRadius: 7,
  color: '#FFFFFF',
  fontFamily: 'Pretendard',
  fontSize: 20,
  fontWeight: 500,
  lineHeight: '28px',
  textAlign: 'center',
});

export const FileIcon = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  display: 'block',
});

export const InfoBlock = styled(Box)({
  padding: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

export const FileName = styled(Typography)({
  fontSize: 13,
  fontWeight: 500,
  display: 'flex',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  '& .name': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: 1,
    minWidth: 0,
  },
  '& .ext': {
    flexShrink: 0,
  },
});

export const FileMeta = styled(Typography)({
  color: 'var(--dk-text-secondary, #888D96)',
  fontFamily: 'Pretendard',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '18px',
});

export const DeleteButton = styled('button')({
  zIndex: 1,
  cursor: 'pointer',
  padding: 0,
  margin: 0,
  border: 0,
  position: 'absolute',
  top: -8,
  right: -8,
  width: 20,
  height: 20,
  borderRadius: '50%',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.16)',
  backgroundColor: '#4D5157',
  color: '#FFFFFF',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > img': {
    width: 10,
    height: 10,
    display: 'block',
    filter: 'brightness(0) invert(1)',
  },
  '&:hover': {
    backgroundColor: '#34383D',
  },
  '&:focus-visible': {
    outline: '2px solid var(--dk-accent, #0066CC)',
    outlineOffset: 2,
  },
});

export const ActionButtons = styled(Box)({
  position: 'absolute',
  bottom: 8,
  right: 8,
  display: 'flex',
  gap: 4,
  zIndex: 1,
});

export const DownloadButton = styled('button')({
  position: 'absolute',
  top: 4,
  left: 4,
  width: 28,
  height: 28,
  padding: 0,
  margin: 0,
  border: 0,
  borderRadius: 4,
  backgroundColor: 'var(--dk-bg, #FFFFFF)',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2,
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.16)',
  '&:hover': {
    backgroundColor: 'var(--dk-bg-subtle, #F5F5F5)',
  },
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  '&:focus-visible': {
    outline: '2px solid var(--dk-accent, #0066CC)',
    outlineOffset: 2,
  },
  '& svg': {
    width: 20,
    height: 20,
    display: 'block',
  },
});
